import { createFrontendPlugin, PageBlueprint } from '@backstage/frontend-plugin-api';
import { CreateApplicationPage } from './CreateApplicationPage';

const createApplicationPage = PageBlueprint.make({
  params: {
    path: '/create-app',
    title: 'Create Application',
    loader: () => Promise.resolve(<CreateApplicationPage />),
  },
});

// A brand-new page needs createFrontendPlugin (defines a new plugin/route),
// NOT createFrontendModule (which only EXTENDS an already-existing plugin's
// extension points, e.g. nav/home below extend the existing 'app'/'home'
// plugins). Using createFrontendModule with a novel pluginId compiled fine
// and even shipped the page's code in the bundle, but never actually
// registered a route — real 404, found via Playwright, not by inspection.
export const createAppPlugin = createFrontendPlugin({
  pluginId: 'create-app',
  extensions: [createApplicationPage],
});
